import ReactGA from 'react-ga4';
import { Result } from '@hitiq/generic';
import { Logger, LogType } from '@hitiq/logger';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { Persistance } from '../../dataStorePersistence/persistence';
import { Translator } from '../translator.interface';
import { Assessment, AssessmentBackend } from './assessments.interfaces';

export const createAssessmentThunk = createAsyncThunk(
  'assessment/createAssessment',
  async (
    payload: {
      translator: Translator<AssessmentBackend, Assessment>;
      persistence: Persistance<AssessmentBackend>;
      loggingService: Logger;
      resource: Assessment;
    },
    thunkAPI,
    // TODO: figure out return type of rejectWithValue something like RejectWithValue<Alert>
    // eslint-disable-next-line consistent-return
  ): Promise<boolean | any> => {
    const { loggingService, persistence, translator, resource } = payload;

    const assessment = newAssessment(resource);
    const backendResource = translator.translateOneToBackendModel(assessment);
    const result = await persistence.create(backendResource);
    if (!result.success) {
      loggingService.log(
        LogType.error,
        `Assessment: creation failed: ${result.error}`,
      );
      return onError(thunkAPI, result.error);
    }
    loggingService.log(LogType.info, `Assessment: ${result.data.id} created.`);

    ReactGA.event({
      category: 'Assessment',
      action: 'Create',
    });
    return true;
  },
);

function newAssessment(resource: Assessment): Assessment {
  return {
    id: 'not empty',
    modelType: ModelTypes.Assessment,
    assessment: { ...resource.assessment },
    accountId: resource.accountId,
    creatorAccountId: '',
    playerId: resource.playerId,
    copyOfId: '_ORIGINAL_',
    accountName: resource.accountName,
    playerFullName: resource.playerFullName,
    createdByAccountId: resource.createdByAccountId,
    createdByAccountName: resource.createdByAccountName,
    createdByUserId: resource.createdByUserId,
    createdByUserFullName: resource.createdByUserFullName,
    pdfS3FileKey: resource.pdfS3FileKey,
    timeZoneOffset: resource.timeZoneOffset,
  };
}

function onError(thunkAPI: any, error: Error) {
  // TODO: remove case ? or keep it so we can reuse it in a retry.
  return thunkAPI.rejectWithValue({
    heading: 'Unable to create assessment',
    message: error.message,
    severity: 'error',
    id: uuidv4(),
  });
}
